var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-10 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
        },
        [
          _c(
            "md-button",
            { staticClass: "md-fab", attrs: { to: "/bm/menu" } },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-75 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-card",
            { staticStyle: { width: "100%" } },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v("Beispiele für Geschäftsmodelle")
                ])
              ]),
              _vm._v(" "),
              _c("md-card-content", [
                _c(
                  "div",
                  {
                    staticClass: "md-layout md-gutter md-alignment-top-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
                      },
                      [
                        _c(
                          "md-card",
                          { staticClass: "margin-twenty" },
                          [
                            _c(
                              "md-card-header",
                              [
                                _c("md-card-header-text", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Gillette")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "md-subhead" }, [
                                    _vm._v(
                                      "\n                      Hersteller von Nassrasierern oder auch von Druckern\n                      bauen in ihren jeweiligen Geschäftsmodellen auf den\n                      sogenannten Lock-in-Effekt...\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-media",
                                  { attrs: { "md-medium": "" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/gilette.png",
                                        alt: "People"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-card-actions",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: "/bm/examples/Gilette" }
                                    }
                                  },
                                  [_c("md-button", [_vm._v("Anschauen")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
                      },
                      [
                        _c(
                          "md-card",
                          { staticClass: "margin-twenty" },
                          [
                            _c(
                              "md-card-header",
                              [
                                _c("md-card-header-text", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Nespresso")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "md-subhead" }, [
                                    _vm._v(
                                      "\n                      Nespresso nutzt neben dem bereits bekannten\n                      Lock-in-Effekt exklusive Vertriebskanäle um die\n                      Hochwertigkeit des Wertangebotes zu unterstreichen...\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-media",
                                  { attrs: { "md-medium": "" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/nespresso.png",
                                        alt: "People"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-card-actions",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: "/bm/examples/Nespresso" }
                                    }
                                  },
                                  [_c("md-button", [_vm._v("Anschauen")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
                      },
                      [
                        _c(
                          "md-card",
                          { staticClass: "margin-twenty" },
                          [
                            _c(
                              "md-card-header",
                              [
                                _c("md-card-header-text", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Daimler")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "md-subhead" }, [
                                    _vm._v(
                                      "\n                      Daimler ist ein Hersteller von Personenkraftwagen und\n                      Nutzfahrzeugen. Ihre bekannteste Marke ist\n                      Mercedes-Benz. Das Unternehmen ist außerdem Anbieter von\n                      Mobilitäts- und Finanzdienstleistungen.\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-media",
                                  { attrs: { "md-medium": "" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/daimler.png",
                                        alt: "People"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-card-actions",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: "/bm/examples/Daimler" }
                                    }
                                  },
                                  [_c("md-button", [_vm._v("Anschauen")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
                      },
                      [
                        _c(
                          "md-card",
                          { staticClass: "margin-twenty" },
                          [
                            _c(
                              "md-card-header",
                              [
                                _c("md-card-header-text", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Skype")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "md-subhead" }, [
                                    _vm._v(
                                      "\n                      Skype bietet ein faszinierendes Beispiel für ein\n                      Freemium-Muster, das den Telekommunikationssektor durch\n                      die Bereitstellung kostenloser Anrufdienste über das\n                      Internet verändert hat...\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-media",
                                  { attrs: { "md-medium": "" } },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/static/skype.png",
                                        alt: "People"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-card-actions",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: "/bm/examples/Skype" }
                                    }
                                  },
                                  [_c("md-button", [_vm._v("Anschauen")])],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticStyle: { "font-size": "8pt" } }, [
                  _c("strong", [_vm._v("Bildquellen:")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "Gilette: https://news.gillette.com/multimedia\n            "
                  ),
                  _c("br"),
                  _vm._v(
                    "Nespresso:\n            https://www.nestle-nespresso.com/media/library/pictures\n            "
                  ),
                  _c("br"),
                  _vm._v(
                    "Daimler:\n            https://www.daimler.com/system/img/img-logo-daimler-svg.svg\n            "
                  ),
                  _c("br"),
                  _vm._v(
                    "Skype:\n            https://secure.skypeassets.com/content/dam/scom/legal/brand-guidelines/skype-icon.svg\n            "
                  ),
                  _c("br")
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-15 md-medium-size-20 md-small-size-20 md-xsmall-size-40"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42302abc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42302abc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/example/BMExample.vue
// module id = null
// module chunks = 